"use strict";

(function ($) {
  /*
  Clone search to header and show it if scroll is higher than top pos
  Automatically update each inputs if value change
  */
  $.fn.moveOnScroll = function () {
    var $that = $(this),
        $body = $('.js-body'),
        inputClass = '.js-private-search-input',
        $button = $('.js-toggle-nav'),
        scrollClass = 'is-scrolled';
    /* Clone form to header on init */

    $that.clone().removeClass('.js-private-search').addClass('js-clone-search').appendTo('.js-search-fixed');
    /* Update input value */

    $(inputClass).on('input', function () {
      $(inputClass).val($(this).val());
    });
    /* Verify position of scroll */

    var setSearchClass = function setSearchClass() {
      var scrollTop = $(window).scrollTop(),
          offsetButtonTop = $('.js-header').outerHeight(),
          offsetTop = $that.offset().top - offsetButtonTop / 2;

      if (scrollTop > offsetTop && !$body.hasClass(scrollClass)) {
        $body.addClass(scrollClass);
      } else if (scrollTop <= offsetTop && $body.hasClass(scrollClass)) {
        $body.removeClass(scrollClass);
      }
    };

    $(window).on('scroll', setSearchClass);
    $(window).on('resize', setSearchClass);
  };
})(jQuery);

$(function () {
  if ($('.js-private-search').length) {
    $('.js-private-search').moveOnScroll();
  }
});